// Official UTMify UTM-tracking script loader.
// Injects https://cdn.utmify.com.br/scripts/utms/latest.js exactly as documented.
// This does NOT touch or interfere with the Meta Pixel setup.

const UTMIFY_SRC = "https://cdn.utmify.com.br/scripts/utms/latest.js";

export function loadUtmify(): void {
  if (typeof document === "undefined") return;

  // Avoid injecting the script twice (e.g. on hot reloads).
  if (document.querySelector(`script[src="${UTMIFY_SRC}"]`)) return;

  const script = document.createElement("script");
  script.src = UTMIFY_SRC;
  script.async = true;
  script.defer = true;
  script.setAttribute("data-utmify-prevent-xcod-sck", "");
  script.setAttribute("data-utmify-prevent-subids", "");

  document.head.appendChild(script);
}
